import { useState } from "react";
import { View } from "react-native";
import { useUnreadNotificationCount } from "@src/packages/care/useNotifications";
import SearchButton from "./SearchButton";
import LanguageButton from "./LanguageButton";
import ProfileAvatarButton from "./ProfileAvatarButton";
import {
  NotificationBellButton,
  NotificationCenterSheet,
} from "../screens/notifications";
import { SearchSheet } from "../screens/search";

declare const __DEV__: boolean | undefined;

function shouldOpenNotificationFixture() {
  if (
    !(__DEV__ || process.env.EXPO_PUBLIC_DEV_TOOLS === "true") ||
    typeof window === "undefined"
  ) {
    return false;
  }
  return (
    new URLSearchParams(window.location.search).get(
      "dev_notifications_open",
    ) === "true"
  );
}

export default function HeaderActions() {
  const [notificationsVisible, setNotificationsVisible] = useState(
    shouldOpenNotificationFixture,
  );
  const [searchVisible, setSearchVisible] = useState(false);
  const { data: unreadCount = 0 } = useUnreadNotificationCount();

  return (
    <>
      <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
        <LanguageButton />
        <SearchButton onPress={() => setSearchVisible(true)} />
        <NotificationBellButton
          hasUnread={unreadCount > 0}
          onPress={() => setNotificationsVisible(true)}
        />
        <ProfileAvatarButton />
      </View>
      <SearchSheet
        visible={searchVisible}
        onClose={() => setSearchVisible(false)}
      />
      <NotificationCenterSheet
        visible={notificationsVisible}
        onClose={() => setNotificationsVisible(false)}
      />
    </>
  );
}
